// extracted by mini-css-extract-plugin
export var container = "_8s-0";
export var icon = "_8s-1";
export var text = "_8s-2";